import { render, staticRenderFns } from "./DeploymentTab.vue?vue&type=template&id=0cdfb146&scoped=true&"
import script from "./DeploymentTab.vue?vue&type=script&lang=js&"
export * from "./DeploymentTab.vue?vue&type=script&lang=js&"
import style0 from "./DeploymentTab.vue?vue&type=style&index=0&id=0cdfb146&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdfb146",
  null
  
)

export default component.exports
import {QIcon,QTooltip,QSelect,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QTooltip,QSelect,QInput})
